import { UserRoles, CompanySetting, CompanySettingMap } from '@rapid-recovery-agency-inc/insightt-shared';
import { CompanySettingRoleAllowed, CompanySettingUserAllowed } from '../modules/system/redux/types';
import { SessionUser as SessionUserLegacy } from '@rapid-recovery-agency-inc/insightt-shared';

export const getIsAdmin = (user: SessionUserLegacy): boolean => user?.role?.role === UserRoles.ADMIN_ROLE;

export const getIsSuperAdmin = (user: SessionUserLegacy): boolean =>
  user?.role?.role === UserRoles.SUPER_ADMIN_ROLE;

export const getIsInAdminGroup = (user: SessionUserLegacy): boolean => getIsAdmin(user) || getIsSuperAdmin(user);

export const getIsManager = (user: SessionUserLegacy): boolean => user?.role?.role === UserRoles.MANAGER_ROLE;

export const getIsDriverOrManager = (user: SessionUserLegacy): boolean =>
  user?.role?.role === UserRoles.DRIVER_ROLE || getIsManager(user);

export const getIsAdminOrManager = (user: SessionUserLegacy): boolean =>
  getIsInAdminGroup(user) || getIsManager(user);

export const getIfUserCanDeleteRHL = (user: SessionUserLegacy, companySettingsMap: CompanySettingMap): boolean => {
  if (!user) return false;

  if (getIsSuperAdmin(user)) return true;

  const settingUserAllowed = companySettingsMap[CompanySetting.RHL_USERS_ALLOWED_TO_DELETE];
  const settingRolesAllowed = companySettingsMap[CompanySetting.RHL_ROLES_ALLOWED_TO_DELETE];

  // IF SETTING IS NOT SET, ALLOW DEFAULT ROLES
  if (!settingRolesAllowed) return getIsAdminOrManager(user);

  //CHECK BY USER ID
  const usersAllowed = JSON.parse(settingUserAllowed || '[]');
  if (usersAllowed.find((userAllowed: CompanySettingUserAllowed) => userAllowed.id === user.id)) return true;

  // CHECK BY ROLE
  const rolesAllowed = JSON.parse(settingRolesAllowed);
  if (rolesAllowed.find((roleAllowed: CompanySettingRoleAllowed) => roleAllowed.id === user.roleId)) return true;

  return false;
};

export const includeRDNorDRN = (str: string): boolean => {
  const isRDNorDrnId = /(^|\s+)(RDN|DRN)(:?)(((\s|:)+\S*)|$)/g;
  return isRDNorDrnId.test(str);
};

export const validateUnknownRole = (str: string): boolean => {
  const isUnknownRole = /^\s*Unknown\s+(Agent|User|Spotter)\s*$/i;
  return isUnknownRole.test(str);
};
